import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';
import Breadcrumb from '../../../components/feature/Breadcrumb';
import FAQSchema from '../../../components/feature/FAQSchema';
import { useEffect } from 'react';

export default function IstanbulAnadoluPage() {
  useEffect(() => {
    document.title = 'İstanbul Anadolu Yakası Fiber Optik ve Güvenlik Sistemleri | Fiber Ek';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İstanbul Anadolu Yakası fiber kablo tamiri, fiber optik sonlandırma, fusion splicing, OTDR test, IP kamera sistemleri ve güvenlik çözümleri. Kadıköy, Ümraniye, Ataşehir, Kartal, Pendik.');
    }

    // Canonical link
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `${import.meta.env.VITE_SITE_URL}/bolgeler/istanbul-anadolu`;
    document.head.appendChild(canonical);

    // Open Graph tags
    const ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.content = 'İstanbul Anadolu Yakası Fiber Optik ve Güvenlik Sistemleri | Fiber Ek';
    document.head.appendChild(ogTitle);

    const ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    ogDescription.content = 'İstanbul Anadolu Yakası\'nda fiber optik altyapı, IP kamera, yangın alarm ve güvenlik sistemleri. Uzman ekip, kaliteli hizmet. ☎ +90 553 716 55 61';
    document.head.appendChild(ogDescription);

    const ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    ogUrl.content = `${import.meta.env.VITE_SITE_URL}/bolgeler/istanbul-anadolu`;
    document.head.appendChild(ogUrl);

    const ogType = document.createElement('meta');
    ogType.setAttribute('property', 'og:type');
    ogType.content = 'website';
    document.head.appendChild(ogType);

    const ogLocale = document.createElement('meta');
    ogLocale.setAttribute('property', 'og:locale');
    ogLocale.content = 'tr_TR';
    document.head.appendChild(ogLocale);

    // JSON-LD Schema
    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Fiber Ek - İstanbul Anadolu Yakası",
      "description": "İstanbul Anadolu Yakası'nda fiber optik altyapı, IP kamera, yangın alarm ve güvenlik sistemleri",
      "areaServed": "İstanbul Anadolu Yakası",
      "telephone": "+905537165561",
      "url": `${import.meta.env.VITE_SITE_URL}/bolgeler/istanbul-anadolu`,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "İstanbul",
        "addressRegion": "İstanbul",
        "addressCountry": "TR"
      }
    });
    document.head.appendChild(schema);

    return () => {
      document.head.removeChild(canonical);
      document.head.removeChild(ogTitle);
      document.head.removeChild(ogDescription);
      document.head.removeChild(ogUrl);
      document.head.removeChild(ogType);
      document.head.removeChild(ogLocale);
      document.head.removeChild(schema);
    };
  }, []);

  const faqs = [
    {
      question: 'İstanbul Anadolu Yakası\'nda fiber kablo tamiri hizmeti veriyor musunuz?',
      answer: 'Evet, Kadıköy, Ümraniye, Ataşehir, Kartal, Pendik, Maltepe, Tuzla ve tüm Anadolu Yakası ilçelerinde 7/24 acil fiber arıza müdahale hizmeti veriyoruz. 30 dakika içinde yerinde oluyoruz.'
    },
    {
      question: 'Metro ethernet fiber ek işlemi ne kadar sürer?',
      answer: 'Metro ethernet fiber ek işlemleri genellikle 2-4 saat içinde tamamlanır. Fusion splicing ve OTDR test dahil profesyonel sonlandırma hizmeti sunuyoruz.'
    },
    {
      question: 'Anadolu Yakası\'nda hangi güvenlik sistemlerini kuruyorsunuz?',
      answer: 'IP kamera sistemleri, hırsız alarm sistemleri, yangın alarm sistemleri, geçiş kontrol sistemleri, turnike ve bariyer sistemleri kurulumu yapıyoruz. Özellikle Dudullu OSB, Ümraniye ve Kartal sanayi bölgelerinde aktif çalışıyoruz.'
    },
    {
      question: 'OM3 ve OM4 fiber ek farkı nedir?',
      answer: 'OM3 fiber 10 Gbps hıza kadar 300 metre, OM4 ise 550 metre mesafeye kadar destek verir. Fabrika ve veri merkezi projelerinde OM4 fiber ek tercih edilir. Her iki tip için de profesyonel fusion splicing hizmeti sunuyoruz.'
    }
  ];

  return (
    <>
      <FAQSchema faqs={faqs} />
      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
        <Navbar />
        <FloatingButtons />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/d129638e8b1da1e2ad711d24df6a2b41.jpg')] bg-cover bg-center opacity-20"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-blue-600/10 via-transparent to-slate-900/50"></div>
          
          <div className="container mx-auto px-4 relative z-10">
            <Breadcrumb 
              items={[
                { label: 'Ana Sayfa', path: '/' },
                { label: 'Bölgeler', path: '/' },
                { label: 'İstanbul Anadolu', path: '/locations/istanbul-anadolu' }
              ]} 
            />

            <div className="max-w-4xl mx-auto text-center mt-12">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                İstanbul Anadolu Yakası Fiber Optik ve Güvenlik Sistemleri
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Kadıköy, Ümraniye, Ataşehir, Kartal, Pendik ve Tüm Anadolu Yakası'nda Profesyonel Fiber Kablo Tamiri ve Güvenlik Çözümleri
              </p>
              <div className="flex flex-wrap gap-4 justify-center">
                <a 
                  href="tel:+905537165561"
                  className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  Hemen Ara
                </a>
                <a 
                  href="https://wa.me/905537165561"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 bg-slate-800/50">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              
              {/* Fiber Optik Hizmetleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-flashlight-line text-blue-500"></i>
                  Anadolu Yakası Fiber Optik Hizmetleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  İstanbul Anadolu Yakası'nda <strong>fiber kablo tamiri</strong>, <strong>fiber optik sonlandırma</strong> ve <strong>fusion splicing hizmeti</strong> konusunda 10+ yıllık deneyimimizle yanınızdayız. Kadıköy, Ümraniye, Ataşehir, Kartal, Pendik, Maltepe, Tuzla ve çevre ilçelerde 7/24 <strong>acil fiber arıza</strong> müdahale ekibimiz hazır.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Fiber Kablo Tamiri ve Acil Servis</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Anadolu Yakası'nın yoğun iş merkezleri ve sanayi bölgelerinde yaşanan <strong>fiber kablo tamiri</strong> ihtiyaçlarına anında yanıt veriyoruz. İnşaat kazaları, altyapı çalışmaları veya doğal yıpranma nedeniyle kesilen fiber kablolarınızı profesyonel ekipmanlarla onarıyoruz. <strong>OTDR test hizmeti</strong> ile fiber hattınızdaki tüm bağlantı noktalarını analiz ediyor, kayıp değerlerini raporluyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Metro Ethernet Fiber Ek ve Sonlandırma</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Metro ethernet fiber ek</strong> projelerinde uzmanlaşmış ekibimiz, operatör hatları arasında yüksek hızlı bağlantılar kuruyor. <strong>SC LC konnektör sonlandırma</strong> işlemlerinde hassas ölçüm cihazları kullanarak minimum kayıp değerleri elde ediyoruz. <strong>OM3 OM4 fiber ek</strong> işlemlerinde uluslararası standartlara uygun çalışıyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Bina ve Fabrika Fiber Altyapı Projeleri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Dudullu OSB, Ümraniye Organize Sanayi Bölgesi, Kartal ve Pendik'teki fabrikalarda <strong>fabrika fiber altyapı</strong> kurulumu gerçekleştiriyoruz. <strong>Bina fiber kablo tamiri</strong> ve yeni nesil fiber altyapı projelerinde A'dan Z'ye hizmet sunuyoruz. Plaza ve iş merkezlerinde <strong>fiber ek hizmeti</strong> ile yüksek hızlı internet altyapısı sağlıyoruz.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/fiber-services/fiber-cable-repair" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-tools-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Fiber Kablo Tamiri</h4>
                    <p className="text-gray-400 text-sm">Acil arıza müdahalei ve profesyonel tamir</p>
                  </Link>
                  <Link to="/fiber-services/fiber-termination" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-link text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Fusion Splicing</h4>
                    <p className="text-gray-400 text-sm">Hassas fiber ekleme ve sonlandırma</p>
                  </Link>
                </div>
              </div>

              {/* Güvenlik Sistemleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-shield-check-line text-blue-500"></i>
                  Güvenlik Sistemleri ve IP Kamera Çözümleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  İstanbul Anadolu Yakası'nda <strong>IP kamera sistemleri</strong>, <strong>hırsız alarm sistemleri</strong>, <strong>yangın alarm sistemleri</strong> ve <strong>geçiş kontrol sistemleri</strong> kurulumu yapıyoruz. Dudullu OSB, Ümraniye sanayi bölgesi ve Kartal'daki fabrikalar için özel güvenlik projeleri geliştiriyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">IP Kamera Sistemleri ve Güvenlik Kameraları</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Yüksek çözünürlüklü <strong>IP kamera sistemleri</strong> ile işletmenizi 7/24 izliyoruz. Gece görüş teknolojisi, hareket algılama, uzaktan erişim ve bulut kayıt özellikleriyle donatılmış kamera sistemleri kuruyoruz. Ümraniye, Ataşehir ve Kadıköy'deki iş merkezleri için özel güvenlik projeleri tasarlıyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Hırsız ve Yangın Alarm Sistemleri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Hırsız alarm sistemleri</strong> ile işyerinizi izinsiz girişlere karşı koruyoruz. Hareket sensörleri, manyetik kontaklar ve sesli uyarı sistemleri entegrasyonu sağlıyoruz. <strong>Yangın alarm sistemleri</strong> kurulumlarında TSE standartlarına uygun duman dedektörleri, ısı sensörleri ve acil durum sirenleri kullanıyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Turnike ve Bariyer Sistemleri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Turnike sistemleri</strong> ve <strong>bariyer sistemleri</strong> ile fabrika ve iş merkezlerinizde personel ve araç giriş-çıkışlarını kontrol ediyoruz. Kartlı geçiş, yüz tanıma ve plaka okuma sistemleri ile entegre <strong>geçiş kontrol sistemleri</strong> kuruyoruz.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/security-systems/ip-camera-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-camera-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">IP Kamera Sistemleri</h4>
                    <p className="text-gray-400 text-sm">Profesyonel güvenlik kamerası kurulumu</p>
                  </Link>
                  <Link to="/security-systems/fire-alarm-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-alarm-warning-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Yangın Alarm Sistemleri</h4>
                    <p className="text-gray-400 text-sm">TSE standartlarında yangın algılama</p>
                  </Link>
                </div>
              </div>

              {/* Hizmet Verdiğimiz İlçeler */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6">Hizmet Verdiğimiz İlçeler</h2>
                <div className="grid md:grid-cols-3 gap-4">
                  {['Kadıköy', 'Ümraniye', 'Ataşehir', 'Kartal', 'Pendik', 'Maltepe', 'Tuzla', 'Sultanbeyli', 'Sancaktepe'].map((ilce) => (
                    <div key={ilce} className="bg-slate-800/30 p-4 rounded-lg border border-slate-700/30">
                      <i className="ri-map-pin-line text-blue-500 mr-2"></i>
                      <span className="text-gray-300">{ilce}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* FAQ */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-8">Sıkça Sorulan Sorular</h2>
                <div className="space-y-6">
                  {faqs.map((faq, index) => (
                    <div key={index} className="border-b border-slate-700/50 pb-6 last:border-0">
                      <h3 className="text-xl font-bold text-white mb-3">{faq.question}</h3>
                      <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="py-20 bg-slate-900/30">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl font-bold text-white mb-8 text-center">Konum</h2>
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d385396.3210609283!2d29.08253!3d41.0082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac7a4b6d4e0e1%3A0x3e6f8e3e3e3e3e3e!2zxLBzdGFuYnVsIEFuYWRvbHUgWWFrYXPEsQ!5e0!3m2!1str!2str!4v1234567891"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="İstanbul Anadolu Yakası Harita"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}